import React from "react";
import "../assets/css/contact.css";
import SubHero from "../components/SubHero";
import ContactCard from "../components/ContactCard";
import { MessagesSquare, Phone, Settings } from "lucide-react";
// import ContactForm from "../components/ContactForm";

const Contact = () => {
  return (
    <>
      <SubHero name="contact" />
      <div className="contact-container">
        <p>contact us</p>
        <h1>Feel free to get in touch with nexatrux</h1>
        <div className="contact-g">
          {contactData.map((item, index) => (
            <ContactCard contactData={item} key={index} />
          ))}
        </div>
      </div>
      {/* <ContactForm /> */}
    </>
  );
};

const contactData = [
  {
    title: "Know",
    header: "About us",
    desc: "Pioneering Tech For Smarter Tomorrow",
    icon: <Settings />,
  },
  {
    title: "write",
    header: "send email",
    desc: "info@nexarux.com",
    desc2: "nexatrux@gmail.com",
    icon: <MessagesSquare />,
  },
  {
    title: "Book",
    header: "call now",
    desc: "(+234) 802-055-4163",
    desc2: "(+234) 8105-182900",
    icon: <Phone />,
  },
];
export default Contact;
